exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AmbassadorshipCard {\n  border-left-width: 6px !important;\n  border-radius: 15px !important;\n}\n.AmbassadorshipCard .background-primary {\n  background-color: #a05dcd94;\n}\n", ""]);

// exports
